import { ChecklistItemRecord } from "models/view-models/block-configurations/checklist-item-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";
import QueryHookFactory from "utilities/hooks/queries/query-hook-factory";

export interface SharedChecklistBlockConfigurationChecklistItemsPathParams {
    pageGuid: string;
    configurationId: number;
}

export interface SharedChecklistBlockConfigurationChecklistItemsQueryParams {
    recipient?: string;
}

const resourceEndpoint: string =
    "public/pages/:pageGuid/blocks/configurations/checklist/:configurationId/checklistItems";
const key = "shared-block-configurations-checklist-checklistitems";

const resourceType = ChecklistItemRecord;

const SharedChecklistBlockConfigurationChecklistItemService = {
    key,
    useNestedList: ServiceHookFactory.useNestedList<
        ChecklistItemRecord,
        SharedChecklistBlockConfigurationChecklistItemsPathParams,
        SharedChecklistBlockConfigurationChecklistItemsQueryParams
    >(resourceType, resourceEndpoint),
    useListQuery: QueryHookFactory.useNestedListQuery<
        ChecklistItemRecord,
        SharedChecklistBlockConfigurationChecklistItemsPathParams,
        SharedChecklistBlockConfigurationChecklistItemsQueryParams
    >(key, resourceType, resourceEndpoint),
};

export default SharedChecklistBlockConfigurationChecklistItemService;
